import { render, staticRenderFns } from "./DegreeMapRequirements.vue?vue&type=template&id=0d7670f0&scoped=true"
import script from "./DegreeMapRequirements.vue?vue&type=script&lang=js"
export * from "./DegreeMapRequirements.vue?vue&type=script&lang=js"
import style0 from "./DegreeMapRequirements.vue?vue&type=style&index=0&id=0d7670f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7670f0",
  null
  
)

export default component.exports